import ContratosTemplate from "../components/templates/ContratosTemplate"

const ContratosAdmin = () => {
    return <ContratosTemplate />;
};

export default ContratosAdmin;